import { Params } from './usePlayerInBackground.types.ts';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function usePlayerInBackground(_: Params) {
    // Player backrounding logic is not needed for Web player
}

export default usePlayerInBackground;
